var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71195 5.65712C9.62854 5.65712 9.58684 5.65712 9.54514 5.65712C7.4891 5.65712 5.43723 5.65712 3.3812 5.65712C2.41365 5.65712 1.62543 5.05165 1.4044 4.13719C1.3627 3.95764 1.35019 3.76556 1.34601 3.58183C1.34184 2.73835 1.34601 1.89487 1.34184 1.05139C1.34184 0.617126 1.05408 0.324831 0.649548 0.333182C0.311741 0.341534 0.0156384 0.604599 0.0114679 0.942826C0.00729752 1.99091 -0.0260668 3.039 0.0448313 4.08291C0.140752 5.47757 1.31682 6.69686 2.70141 6.93487C2.93496 6.97662 3.17685 6.9975 3.41456 6.9975C5.4414 7.00168 7.47242 7.00168 9.49926 7.00168C9.55765 7.00168 9.61186 7.00168 9.70778 7.00168C9.6494 7.06014 9.61603 7.10189 9.5785 7.13947C9.11975 7.59879 8.65683 8.05811 8.20225 8.52161C7.83108 8.90159 7.98538 9.50706 8.48584 9.64068C8.74858 9.71167 8.97378 9.63233 9.16562 9.44025C9.96635 8.63435 10.7671 7.83263 11.572 7.03091C11.6512 6.95157 11.7305 6.88059 11.8055 6.80125C12.0599 6.53818 12.0683 6.13315 11.8097 5.87426C10.9214 4.98067 10.0289 4.09126 9.13643 3.20185C8.86118 2.93043 8.46082 2.93461 8.19808 3.18932C7.93117 3.45238 7.92283 3.8616 8.19808 4.14137C8.64849 4.60486 9.10724 5.05583 9.56599 5.51515C9.61186 5.54855 9.64523 5.59031 9.71195 5.65712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back_btn.2b3410a8663d6f2d07601d740cadc523.svg";
export { ForwardRef as ReactComponent };